import { gql } from '@apollo/client';

export const ensureKodoBankAccountForCompanyGQL = gql`
  mutation ensureKodoBankAccountForCompany(
    $ownerCompanyId: String!
    $removeFundingBankAccount: Boolean
    $fundingBankAccountValidationRequestId: String!
    $bankAccountId: String
  ) {
    ensureKodoBankAccountForCompany(
      removeFundingBankAccount:$removeFundingBankAccount
      fundingBankAccountValidationRequestId:$fundingBankAccountValidationRequestId
      input:{ownerCompanyId: $ownerCompanyId, bankAccountId: $bankAccountId}
    ) {
      id
      accountNo
      ifsc
      balance
    }
  }
`;
export const fundingBankAccountForCompanyGQL = gql`
  query fundingBankAccountForCompany(
    $includeDeleted: Boolean
    $companyId: String!
  ) {
    fundingBankAccountForCompany(
      companyId: $companyId
      includeDeleted: $includeDeleted
    ) {
      fundingBankAccountForCompanyOutput {
        id
        accountName
        accountNumber
        ifsc
        lastValidationRequestId
        validatedAt
        isDeleted
        deletedBy
        deletedOn
        addedBy
        addedOn
        bankAccount {
          id
          serviceProviderIntegration {
            id
            key
            serviceProviderIntegrator {
              id
              key
              name
            }
          }
        }
      }
      maximumAuthorizedAccountAllowedForVaFunding
      totalActiveFundingBankAccountForCompany
    }
  }
`;
export const deactivateOrActivateVaForCompanyGQL = gql`
mutation deactivateOrActivateVaForCompany(
  $bankAccountId: String!
  $isActive: Boolean!
  $initiateAccountActivationRequest: Boolean
  $markInternallyOnly: Boolean
) {
  deactivateOrActivateVaForCompany(
    input: {
      bankAccountId: $bankAccountId,
      isActive: $isActive,
      options: {
        initiateAccountActivationRequest: $initiateAccountActivationRequest,
        markInternallyOnly: $markInternallyOnly
      }
    }
  )
}
`;
export const toggleVirtualAccountQuickPayPreferenceForBankAccountGQL = gql`
  mutation toggleVirtualAccountQuickPayPreferenceForBankAccount(
    $bankAccountId: ID!,
    $isPreferredForQuickPayUpi: Boolean,
    $isPreferredForQuickPayBankTransfer: Boolean,
  ) {
    toggleVirtualAccountQuickPayPreferenceForBankAccount(
      input: {
        bankAccountId: $bankAccountId,
        isPreferredForQuickPayUpi: $isPreferredForQuickPayUpi,
        isPreferredForQuickPayBankTransfer: $isPreferredForQuickPayBankTransfer,
      }
    ) {
      success
      message
    }
  }
`;
export const allVirtualAccountsForCompanyViaInternalPortalPaginatedGQL = gql`
  query allVirtualAccountsForCompanyViaInternalPortalPaginated(
    $companyId: String!
    $pagination: PaginationOptions!
    $excludeNonActiveBankAccounts: Boolean
  ) {
    allVirtualAccountsForCompanyViaInternalPortalPaginated(
      companyId: $companyId
      pagination: $pagination
      excludeNonActiveBankAccounts: $excludeNonActiveBankAccounts
    ) {
      items {
        id
        accountNo
        nickname
        ifsc
        upiHandle
        balance
        balanceLastUpdatedAt
        isActive
        activatedAt
        activatedBy {
          fullName
          displayName
        }
        decentroVirtualAccount {
          isActivationRequestInitiated
          isActivationRequestCompleted
        }
        serviceProviderIntegration {
          key
          serviceProviderIntegrator {
            key
            name
          }
        }
        isPreferredForQuickPayBankTransfer
        isPreferredForQuickPayUpi
      }
      meta {
        totalItems
      }
    }
  }
`;
export const getVirtualAccountByIdGQL = gql`
  query getVirtualAccountById(
    $virtualAccountId: String!
    $companyId: String
  ) {
    getVirtualAccountById(
      virtualAccountId: $virtualAccountId
      companyId: $companyId
    ) {
      id
      accountNo
      nickname
      ifsc
      upiHandle
      balance
      balanceLastUpdatedAt
      isActive
      activatedAt
      decentroVirtualAccount {
        isActivationRequestInitiated
        isActivationRequestCompleted
      }
      serviceProviderIntegration {
        key
        isQuickPayUpiSupported
        isQuickPayBankTransferSupported
        serviceProviderIntegrator {
          key
          name
        }
      }
      isPreferredForQuickPayBankTransfer
      isPreferredForQuickPayUpi
    }
  }
`;

export const AccountFundingGQL = {
  ensureKodoBankAccountForCompany: ensureKodoBankAccountForCompanyGQL,
  fundingBankAccountForCompany: fundingBankAccountForCompanyGQL,
  allVirtualAccountsForCompanyViaInternalPortalPaginated: allVirtualAccountsForCompanyViaInternalPortalPaginatedGQL,
  deactivateOrActivateVaForCompany: deactivateOrActivateVaForCompanyGQL,
  getVirtualAccountByIdGQL: getVirtualAccountByIdGQL,
  toggleVirtualAccountQuickPayPreferenceForBankAccountGQL: toggleVirtualAccountQuickPayPreferenceForBankAccountGQL
}
